import {
  faArrowLeftLong,
  faCoins,
  faFileContract,
  faLink,
  faPersonChalkboard,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import {
  ACADEMICYEARID,
  baseURL,
  EDITTASK,
  UPDATETASK,
} from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
export default function UpdateTask() {
  const axiosPrivate = useAxiosPrivate();
  const [Loding, setLoding] = useState(false);
  const Navigate = useNavigate();
  const [selectData, setSelectData] = useState([]);
  const location = useLocation();
  const { id } = location.state || {};

  const [data, setData] = useState({
    name: "",
    description: "",
    taskDate: "",
  });

  //1/ جلب بيانات الشهر للتعديل
  useEffect(() => {
    if (id) {
      axiosPrivate
        .get(`${baseURL}/${EDITTASK}/${id}`)
        .then((res) => {
          setData({
            name: res.data.data.name || "",
            description: res.data.data.description || "",
            taskDate: res.data.data.task_date || "",
          });
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
          toast.error("حدث خطأ أثناء تحميل بيانات الشهر");
        });
    }
  }, [id, axiosPrivate]);

  function handleChange(e) {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(nav, save) {
    setLoding(true);

    try {
      const response = await axiosPrivate.put(`${baseURL}/${UPDATETASK}`, {
        ...data,
        save,
        id,
      });

      toast.success("تم الحفظ بنجاح");

      setData({
        name: "",
        description: "",
        taskDate: "",
      });

      if (nav) {
        Navigate("/DashboardLayout/taskDashbord");
      }
    } catch (error) {
      console.error("حدث خطأ:", error);

      if (error.response && error.response.status === 400) {
        toast.error("لم يتم الحفظ، قد تكون البيانات مكررة أو غير صحيحة");
      } else {
        toast.error("حدث خطأ أثناء الحفظ، حاول مرة أخرى لاحقاً");
      }
    } finally {
      setLoding(false);
    }
  }

  useEffect(() => {
    async function featchmonth() {
      if (data.academicYear) {
        const res = await axiosPrivate.get(
          `${baseURL}/${ACADEMICYEARID}/${data.academicYear}`
        );
        setSelectData(res.data.data);
      }
    }
    featchmonth();
  }, [data.academicYear, axiosPrivate]);

  return (
    <>
      {Loding && <Lodingsubmit />}
      <ToastContainer position="top-center" reverseOrder={false} />

      <div className="p-4 content" dir="rtl">
        <Link
          style={{ display: "block", textAlign: "end" }}
          to="/DashboardLayout/taskDashbord"
        >
          <FontAwesomeIcon
            style={{ color: "var(--brand-200)" }}
            className="fw-bold fs-3 text-end"
            icon={faArrowLeftLong}
          />
        </Link>
        <h2 className="fw-bold"> تعديل المهمه</h2>
        <div className="d-flex align-items-center mb-5">
          <Form onSubmit={(e) => e.preventDefault()} className="Form w-75">
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="name"
                value={data.name}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon
                  className="iconeForm"
                  icon={faPersonChalkboard}
                />
                <span className="textinpout">عنوان المهمه</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                as="textarea"
                name="description"
                value={data.description}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon
                  className="iconeForm"
                  icon={faPersonChalkboard}
                />
                <span className="textinpout">محتوى المهمة </span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="date"
                name="taskDate"
                value={data.taskDate}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <span className="textinpout">تاريخ المهمه :</span>
              </Form.Label>
            </Form.Group>

            <div className="d-flex gap-2">
              <Button
                onClick={() => handleSubmit(true, false)}
                style={{ padding: "0px 40px" }}
                className="custom-brand-btn-dhash"
              >
                إضافة
              </Button>

              <Button
                onClick={() => handleSubmit(true, true)}
                style={{
                  padding: "5px 40px",
                  backgroundColor: "transparent",
                  color: "black",
                }}
                className="custom-reset-btn"
              >
                حفظ كمسودة
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}
